module.exports = __webpack_public_path__ + "img/banner3.82b405b6.png";